import { ArticleWithRelations, RequestWithRelations } from '@/models/request';

export const getQualityControllers = (
  article?: ArticleWithRelations,
  request?: RequestWithRelations
) => {
  const qualityControlStepTrait =
    article?.step?.step === 'quality-control'
      ? article?.step?.config.tasks?.control_quality?.trait
      : undefined;

  const qualityControllers =
    qualityControlStepTrait === 'workshop'
      ? (article?.workshop?.workshopConfig?.qualityControllers ?? [])
      : qualityControlStepTrait === 'store'
        ? (request?.store?.storeConfig?.salesAdvisors ?? [])
        : [];

  return { qualityControlStepTrait, qualityControllers };
};
